import React, { useState, useEffect } from 'react';
import { obtenerAnexoBlobUrl } from '../services/api';
import '../styles/modal.css';
import '../styles/styles.css';

/**
 * Visor seguro de un anexo (Blob + img/iframe según extensión).
 * Patrón compartido por EmpresaDashboard, PanelExamenes, PacienteDashboard y Perfil.
 *
 * Props:
 * - idEva: id de la evaluación a la que pertenece el anexo
 * - anexo: { id_anexo, filename, original_name, observaciones }
 * - onClose: () => void
 * - onDelete: opcional, (e) => void — si se omite, no se muestra el botón de eliminar
 */
const AnexoViewerModal = ({ idEva, anexo, onClose, onDelete }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let urlActual = null;
    let cancelado = false;

    const cargar = async () => {
      setCargando(true);
      setError(null);
      try {
        const url = await obtenerAnexoBlobUrl(idEva, anexo.id_anexo);
        urlActual = url;
        if (!cancelado) setBlobUrl(url);
      } catch (err) {
        console.error('Error al obtener archivo anexo:', err);
        if (!cancelado) setError('No se pudo cargar el anexo. Verifica tus permisos o sesión.');
      } finally {
        if (!cancelado) setCargando(false);
      }
    };
    cargar();

    return () => {
      cancelado = true;
      if (urlActual) URL.revokeObjectURL(urlActual);
    };
  }, [idEva, anexo.id_anexo]);

  const nombre = anexo.original_name || anexo.filename;
  const esImagen = /\.(png|jpe?g|gif|webp|bmp)$/i.test(nombre || '');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container modal-container-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Anexo: {nombre}</h3>
          <button type="button" className="btn-close" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body text-center">
          {anexo.observaciones && (
            <div className="anexo-observaciones-box">
              <strong>Observaciones:</strong>
              <p>{anexo.observaciones}</p>
            </div>
          )}

          <div className="anexo-preview-container">
            {cargando && <p>Cargando archivo de forma segura...</p>}
            {error && <p className="required-text">{error}</p>}
            {!cargando && !error && blobUrl && (
              esImagen ? (
                <img src={blobUrl} alt={nombre} className="anexo-preview-img" />
              ) : (
                <iframe src={blobUrl} title="Vista Anexo" className="anexo-preview-iframe" />
              )
            )}
          </div>
        </div>

        <div className={`modal-footer${onDelete ? ' modal-footer-between' : ''}`}>
          {onDelete && (
            <button type="button" className="btn-danger" onClick={onDelete}>
              <i className="fas fa-trash"></i> Eliminar Anexo
            </button>
          )}
          <button type="button" className="btn-secondary" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnexoViewerModal;
